







































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { auctionModule, authModule } from '@/store';
import { Lot, Wish, ApplicationRecord } from '@/api';
import BidDialog from '@/components/frontend/BidDialog.vue';
import SingleLot from '@/components/frontend/SingleLot.vue';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import AbstractTable from '@/components/admin/AbstractTable.vue';

@Component({
  components: { BidDialog, SingleLot, ConfirmDialog, AbstractTable },
})
export default class extends Vue {
  wishes: Wish[] = [];

  page: number = 1;
  pageLen: number = 0;

  lotDialog: boolean = false;
  bidDialog: boolean = false;
  loadingPrint: boolean = false;

  selectedLot: Lot | null = null;

  selected: ApplicationRecord[] = [];

  wishConfirmDialog: boolean = false;

  allWishes: Wish[] = [];

  printCurrentPage = 1;

  wishHeaders = [
    {
      text: 'Auction Code',
      value: 'lot.auction.code',
      width: 130,
    },
    {
      text: 'Lot Number',
      value: 'lot.number',
      width: 130,
    },
    {
      text: 'Lot',
      value: 'lot.title',
    },
    {
      text: 'Hammer Price',
      value: 'lot.salePrice',
      width: 150,
    },
  ];

  get wishOptions() {
    return {
      itemsPerPage: 20,
      sortBy: ['lot.ordering'],
      sortDesc: [true],
    };
  }

  get wishScope() {
    return () => {
      if (!authModule.user) {
        return;
      }
      return Wish.includes(['lot.auction']).where({
        'lot.auction.status': 'past',
        user: authModule.user.id,
      });
    };
  }

  get singleSelected() {
    return this.selected[0] || null;
  }

  update() {
    (this.$refs.abstractTable as AbstractTable).update();
  }

  formatValue(value: number) {
    if (!value) {
      return;
    }
    const dollarValue = value / 100;
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(dollarValue);
  }

  showLot(lot: Lot) {
    if (!lot.auction.id) {
      return;
    }
    auctionModule.checkAuctionWishes(lot.auction.id);
    auctionModule.checkAuctionBids(lot.auction.id);
    this.selectedLot = lot;
    this.lotDialog = true;
  }

  isCurrent(lot: Lot) {
    if (!lot) {
      return;
    }

    return (
      lot.auction.status === 'current' &&
      (lot.auction.bidsCloseAt >= new Date().toISOString() ||
        lot.auction.bidsCloseAt === null)
    );
  }

  hasBid(lot: Lot) {
    if (!lot || !lot.id) {
      return false;
    }
    const bid = auctionModule.bids[lot.id];
    if (bid) {
      return true;
    } else {
      return false;
    }
  }

  currentBid(lot: Lot) {
    if (!lot || !lot.id || !lot.auction.id) {
      return false;
    }

    const bid = auctionModule.bids[lot.auction.id][lot.id];
    if (bid) {
      const value = bid.value / 100;
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      }).format(value);
    }
  }

  tryBid(lot: Lot) {
    if (!lot) {
      return;
    }
    this.selectedLot = lot;

    if (!authModule.isLoggedIn) {
      authModule.openLoginDialog(this.doBid);
    } else {
      this.doBid();
    }
  }

  tryWishlist(lot: Lot) {
    if (!lot) {
      return;
    }
    this.selectedLot = lot;

    if (!authModule.isLoggedIn) {
      authModule.openLoginDialog(null);
    } else {
      this.toggleWish();
    }
  }

  confirmRemoveWish(lot: Lot) {
    this.selectedLot = lot;
    this.wishConfirmDialog = true;
  }

  async toggleWish() {
    if (
      !this.selectedLot ||
      !this.selectedLot.id ||
      !this.selectedLot.auction.id
    ) {
      return;
    }
    this.wishConfirmDialog = false;

    try {
      const wish =
        auctionModule.wishes[this.selectedLot.auction.id][this.selectedLot.id];
      if (wish) {
        await auctionModule.removeWish(this.selectedLot);
      } else {
        await auctionModule.addWish(this.selectedLot);
        authModule.trackEvent({
          gtag: this.$gtag,
          eventAction: 'add_to_wishlist',
          eventCategory: 'engagement',
          eventLabel: this.selectedLot.title,
        });
      }
    } catch (e) {
      // Error
    } finally {
      this.updateWishes();
    }
  }

  doBid() {
    this.bidDialog = true;
  }

  async print(currentPage: number = 1) {
    if (!authModule.user) {
      return;
    }
    try {
      this.loadingPrint = true;

      const scope = Wish.includes(['lot.auction'])
        .per(100)
        .page(currentPage)
        .order('lot.ordering')
        .where({
          'lot.auction.status': 'current',
          user: authModule.user.id,
        });
      const r = await scope.all();
      const maxPages = r.meta.pagination.pages;
      if (currentPage === 1) {
        this.allWishes = r.data;
      } else {
        this.allWishes = this.allWishes.concat(r.data);
      }

      if (currentPage >= maxPages) {
        setTimeout(() => {
          this.loadingPrint = false;
          window.print();
        }, 200);
      } else {
        this.print(currentPage + 1);
      }
    } catch (e) {
      // Error
    }
  }

  doPrint() {
    this.print();
  }

  printEvent(e: KeyboardEvent) {
    if (
      (e.ctrlKey || e.metaKey) &&
      (e.key === 'p' ||
        e.charCode === 16 ||
        e.charCode === 112 ||
        e.keyCode === 80)
    ) {
      e.cancelBubble = true;
      e.preventDefault();
      e.stopImmediatePropagation();

      this.print();
    }
  }

  async updateWishes() {
    if (!authModule.user) {
      return;
    }

    try {
      const scope = Wish.includes(['lot.auction'])
        .per(12)
        .page(this.page)
        .order('lot.ordering')
        .where({
          'lot.auction.status': 'current',
          user: authModule.user.id,
        });
      const wishes = await scope.all();
      this.pageLen = wishes.meta.pagination.pages;
      this.wishes = wishes.data;
      this.wishes.forEach(async (w: Wish) => {
        if (!w.lot.auction.id) {
          return;
        }
        await auctionModule.checkAuctionBids(w.lot.auction.id);
        await auctionModule.checkAuctionWishes(w.lot.auction.id);
      });
    } catch (err) {
      // Error
    }
  }

  mounted() {
    if (!authModule.isLoggedIn) {
      this.$router.push({
        name: 'login',
        query: { next: window.location.pathname },
      });
    }

    window.addEventListener('keydown', this.printEvent);

    this.updateWishes();
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.printEvent);
  }

  @Watch('page')
  pageChanged() {
    this.updateWishes();
  }
}
